import { onlyDigit } from '@/functions/function.js';
import $ from 'jquery'

export default {
    name: 'edit-consommable',
    components: {},
    props: [],
    data () {
        return {
            loading: false,
			loading_attribut: true,
			libelle: '',
			minimum: 0,
			optimale: 0,
			prix: 0,
			attributs: [],
			consommable_id: 0
        }
    },
    computed: {
        //Chargement de l'article
		medicament() {
			return this.$store.getters['article']
		},

		type() {
			return this.$store.getters['type']
		},

		//Type article
		type_articles() {
			return this.$store.getters['types']
		},
    },
    mounted () {
		this.consommable_id = this.$route.params.id
        setTimeout(() => {
			$('.p-content').fadeIn();
		}, 1000);

		//Initialisation du formulaire de médicament
		const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            article_id: this.$route.params.id
        }
		this.changeType(data, 2);
    },
    methods: {
        async changeType(data, id) {
			this.attributs = []

			await this.$store.dispatch("getArticle", data)

			await this.$store.dispatch("getType", id).then(() => {
				this.getAttributs()
			})
			this.loading_attribut = false
		},

        getAttributs() {
			for (let i = 0; i < this.type['attribut_articles'].length; i++) {
				let valeur = ''
				valeur = this.medicament.attribut[this.type['attribut_articles'][i].libelle]
				this.attributs.push(
					{
						valeur: valeur,
						libelle: this.type['attribut_articles'][i].libelle,
						attribut: this.type['attribut_articles'][i].id
					});
			}
		},

        async submitForm() {

			const isValid = await this.$refs.observer.validate();

			if (isValid) {
				this.loading = true;
				const id = this.$route.params.id

				const data = {
					libelle: this.medicament.libelle,
					prix: (this.medicament.prix != '')?this.medicament.prix:0,
					minimum: (this.medicament.minimum != '')?this.medicament.minimum:0,
					optimale: (this.medicament.optimale != '')?this.medicament.optimale:0,
					type_article: 2,
					attribut: this.attributs
				}


				this.$store.dispatch("editArticle", { id, data }).then(
					response => {
						if (response) {
							this.loading = false;
							this.$router.push({ path: `/consommables/view/`+id })
						} else {
							this.loading = false;
						}
					}
				);
			}

		},

        /**
         * Authorise uniquement les chiffres
         * @param {*} input_id 
        */
        async allowOnlyDigit(input_id)
        {
            onlyDigit.onlyDigit(input_id)
        }
    }   
}


